/**
 * @FileDescription: 我的产品
 * @Author: zhuangjinshan
 * @Date: 2025-12-26
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const RecommendApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/system/company/info';
	},
  /**
	 * @description: 根据解决方案供应商id客户推荐
	 * @param {String} serviceId 解决方案供应商id
	 */
	listRecommendByServiceId: function(serviceId) {
		return axios.post(this.baseUrl() + "/listRecommendByServiceId", { serviceId });
	},
};

export default Object.assign(RecommendApi, BaseApi);
